import PropTypes from 'prop-types';
import { useValidation } from '@eti/providers';
import { SwitchButton as EtiSwitchButton } from '@eti/components';
import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
const mapPropsToProps = _ref => {
  let {
    input,
    meta,
    ...props
  } = _ref;
  return {
    ...props,
    isChecked: props.isChecked || Boolean(input.value),
    hasError: Boolean(meta.touched && meta.invalid),
    onChange: input.onChange
  };
};
const SwitchButton = props => /*#__PURE__*/_jsx(EtiSwitchButton, {
  ...mapPropsToProps(props)
});
const SwitchButtonField = _ref2 => {
  let {
    name,
    formatGet,
    formatSet,
    onChange,
    validationRuleName,
    ...props
  } = _ref2;
  const validate = useValidation(validationRuleName);
  return /*#__PURE__*/_jsx(Field, {
    component: SwitchButton,
    format: formatGet,
    name: name,
    normalize: formatSet,
    onChange: onChange,
    props: {
      name,
      ...props
    },
    validate: validate
  });
};
SwitchButtonField.propTypes = {
  formatGet: PropTypes.func,
  formatSet: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
  validationRuleName: PropTypes.string
};
export default SwitchButtonField;